(function AdzukiFileUpload($, Adzuki)
{
	const component = {
		emits : ['selected-media', 'pending-approval'],
		inject: {
			formatDuration: {
				default: () => undefined
			},
			formatFileSize: {
				default: () => undefined
			},
			fileIcon: {
				default: () => undefined
			},
			openToast: {
				default: () => undefined
			},
			openAlert: {
				default: () => undefined
			},
			sendMediaToParent: {
				default: () => undefined
			},
			normalizeExtension: {
				default: () => undefined
			},
		},
		props: {
			multiple: {
				type   : Boolean,
				default: false
			},
			floatingQueue: {
				type   : Boolean,
				default: false
			},
			sectionInfo: {
				type: Object,
			}
		},
		template: '#adzuki-file-upload',
		data() {
			return {
				dragActive       : false,
				files            : [],
				fileUrl          : '',
				thumbUrl         : '',
				readyToUpload    : false,
				queueExpanded    : false,
				showUpload       : false,
				showWebImport    : false,
				showRecord       : false,
				showStock        : false,
				showCropper      : false,
				activeFileIndex  : 0,
				croppingFileIndex: null,
				uploadKeyCounter : 0,
				tosConfirm       : false,
				cropperProps     : null,
				existFileProps   : null,
				existingFile     : null,
				isLoading        : false,
				existingFileList : [],
				savingCopy       : false,
				allowedExtensions: [],
				showPopForm      : false,
				popFormMediaId   : null,
				importErrors     : {},
				importFilename   : '',
				maxFileSize      : 200 * 1024 * 1024
			};
		},
		computed: {
			uploadLimit() {
				const limit = Number(this.sectionInfo && this.sectionInfo.upload_limit);

				return limit > 0 ? limit : 10;
			}
		},
		methods: {
			toggleQueue() {
				this.queueExpanded = !this.queueExpanded;
			},
			tabToggle(tabName) {
				sessionStorage.setItem('upload-tab', tabName);
				switch (tabName) {
					case 'webImport':
						this.showUpload    = false;
						this.showRecord    = false;
						this.showStock     = false;
						this.showWebImport = true;
						break;
					case 'record':
						this.showWebImport = false;
						this.showUpload    = false;
						this.showStock     = false;
						this.showRecord    = true;
						break;
					case 'upload':
						this.showWebImport = false;
						this.showRecord    = false;
						this.showStock     = false;
						this.showUpload    = true;
						break;
					case 'stock':
						this.showWebImport = false;
						this.showRecord    = false;
						this.showUpload    = false;
						this.showStock     = true;
						break;
					default:
						break;
				}
			},
			handleDrop(e) {
				this.dragActive    = false;
				const droppedFiles = Array.from(e.dataTransfer.files);
				this.handleFiles(droppedFiles);
			},
			handleFileSelect(e) {
				const selectedFiles = Array.from(e.target.files);
				console.log('selectedFiles', selectedFiles, 'event', e);
				this.handleFiles(selectedFiles);
				e.target.value = '';
			},
			normalizeFileName(name) {
				return String(name || '').trim().toLowerCase();
			},
			// Mirrors MediaHubComponent::sanitizeFilename so names returned by the server
			// can be matched back to the files still sitting in the queue.
			sanitizeFileName(name) {
				return String(name || '')
					.split(/[\\/]/)
					.pop()
					.toLowerCase()
					.replace(/\s+/g, '_')
					.replace(/[^a-z0-9_\-.]/g, '')
					.replace(/[_-]+/g, '_');
			},
			isExtensionAllowed(extension) {
				if (!this.allowedExtensions || this.allowedExtensions.length === 0) {
					return true;
				}

				const normalized = String(extension || '').toLowerCase();

				return this.allowedExtensions.some(
					allowed => String(allowed).toLowerCase() === normalized
				);
			},
			alertInvalidExtensions(invalidFileNames) {
				if (!invalidFileNames || invalidFileNames.length === 0) {
					return;
				}

				let msg = '';

				if (invalidFileNames.length === 1) {
					msg += `The following file is not allowed: ${invalidFileNames[0]}.`;
				} else {
					msg += `The following files are not allowed: <ul>`;

					for (const file of invalidFileNames) {
						msg += `<li>${file}</li>`;
					}
					msg += `</ul>`;
				}

				if (this.allowedExtensions.length > 0) {
					const allowedExtensions = this.allowedExtensions.map(e => String(e).toUpperCase());

					msg += ` Please select `;

					if (allowedExtensions.length === 1) {
						msg += allowedExtensions[0];
					} else {
						msg += allowedExtensions.slice(0, -1).join(', ') + ' or ' + allowedExtensions.slice(-1);
					}

					msg += ` files only.`;
				}

				this.openAlert('error', 'Error', msg);
			},
			getDuplicateNames(incomingFiles, existingFiles = this.files) {
				const existingNames = new Set(
					(existingFiles || []).map(f => this.normalizeFileName(f.name))
				);

				const seenIncoming = new Set();
				const duplicates   = new Set();

				(incomingFiles || []).forEach(f => {
					const name = this.normalizeFileName(f && f.name);
					if (!name) {
						return;
					}

					if (existingNames.has(name) || seenIncoming.has(name)) {
						duplicates.add(name);
					}
					seenIncoming.add(name);
				});

				return Array.from(duplicates);
			},
			toastInvalidNames(duplicateNames) {
				if (!duplicateNames || duplicateNames.length === 0) {
					return;
				}

				const countLabel = duplicateNames.length === 1 ? 'file' : 'files';

				this.openAlert(
					'error',
					'Error',
					`You have selected ${duplicateNames.length} ${countLabel} with the same name. Please change the file name and try again.`
				);
			},
			addToFiles(fileInfos) {
				console.log('addToFiles', fileInfos);
				const stagedFiles = Array.from(fileInfos || []);

				if (this.files.length + stagedFiles.length > this.uploadLimit) {
					this.openAlert('error', 'Error', 'You have reached the maximum number (' + this.uploadLimit + ') of files allowed for upload. Please remove some files before uploading more.');
					return;
				}

				if (stagedFiles.length === 0) {
					return;
				}

				console.log('incoming', stagedFiles);

				const duplicateNames = this.getDuplicateNames(stagedFiles, this.files);
				if (duplicateNames.length > 0) {
					this.toastInvalidNames(duplicateNames);
				}

				console.log('duplicate names', duplicateNames);

				const filesWithoutDuplicates = stagedFiles.filter(f => {
					const normalized = this.normalizeFileName(f && f.name);
					return normalized && !duplicateNames.includes(normalized);
				});

				console.log('dedupedIncoming', filesWithoutDuplicates);
				if (filesWithoutDuplicates.length === 0) {
					return;
				}

				const filesWithKeys = filesWithoutDuplicates.map(fileInfo => ({
					...fileInfo,
					uploadKey: fileInfo.uploadKey || `upload-${++this.uploadKeyCounter}`,
				}));

				if (this.multiple) {
					this.files = [...this.files, ...filesWithKeys];
				} else {
					this.files = filesWithKeys.slice(0, 1);
				}
				this.importFilename = '';
				this.fileUrl        = '';
				this.thumbUrl       = '';

				if (!this.floatingQueue) {
					this.openAlert('success', 'Success', 'Media added to upload queue');
				}
			},
			getImageDimensions(fileInfo) {
				const existingWidth  = Number(fileInfo && fileInfo.width);
				const existingHeight = Number(fileInfo && fileInfo.height);

				if (
					Number.isFinite(existingWidth) && existingWidth > 0
					&& Number.isFinite(existingHeight) && existingHeight > 0
				) {
					return Promise.resolve(fileInfo);
				}

				return new Promise((resolve) => {
					const img = new Image();

					img.onload = () => {
						fileInfo.width  = img.naturalWidth || img.width;
						fileInfo.height = img.naturalHeight || img.height;
						resolve(fileInfo);
					};

					img.onerror = () => resolve(fileInfo);
					img.src     = fileInfo.previewUrl;
				});
			},
			getVideoDuration(fileInfo) {
				const existingDuration = Number(fileInfo && fileInfo.duration);

				if (Number.isFinite(existingDuration) && existingDuration > 0) {
					return Promise.resolve(fileInfo);
				}

				return new Promise((resolve) => {
					const video   = document.createElement('video');
					video.preload = 'metadata';
					video.muted   = true;

					const finish = () => {
						const duration = Number(video.duration);

						if (Number.isFinite(duration) && duration > 0) {
							fileInfo.duration = Math.floor(duration);
						}

						resolve(fileInfo);
					};

					video.onloadedmetadata = () => {
						// Some browsers report Infinity until a seek forces the metadata to resolve
						if (Number.isFinite(video.duration) && video.duration > 0) {
							finish();
							return;
						}

						video.onseeked = finish;

						try {
							video.currentTime = 1e101;
						} catch (e) {
							finish();
						}
					};

					video.onerror = () => resolve(fileInfo);
					video.src     = fileInfo.previewUrl;
				});
			},
			async handleFiles(files) {
				const validFiles         = [];
				const invalidExtensions  = [];
				const oversizedFiles     = [];

				Array.from(files).forEach(file => {
					if (file.size > this.maxFileSize) {
						oversizedFiles.push(file.name);
						return;
					}

					const fileInfo = {
						name        : file.name,
						size        : file.size,
						extension   : file.name.split('.').pop().toLowerCase(),
						previewUrl  : '',
						filePath    : '',
						originalFile: file,
						fileOrigin  : (file.fileOrigin && typeof file.fileOrigin === 'string') ? file.fileOrigin : 'uploaded',
					};

					if (file.type.startsWith('image/')) {
						fileInfo.type       = 'image';
						fileInfo.previewUrl = URL.createObjectURL(file);
					} else if (file.type.startsWith('video/')) {
						fileInfo.type = 'video';
						fileInfo.previewUrl = URL.createObjectURL(file);

						if (file.captions) {
							fileInfo.captions = file.captions;
							fileInfo.captionsUrl = file.captionsUrl;
						}

						const video   = document.createElement('video');
						video.preload = 'metadata';

						if (fileInfo.captionsUrl) {
							const track = document.createElement('track');
							track.kind = 'captions';
							track.label = 'English';
							track.srclang = 'en';
							track.src = fileInfo.captionsUrl;
							track.default = true;
							video.appendChild(track);
						}

						const getDuration = new Promise((resolve) => {
							video.onloadedmetadata = () => {
								video.currentTime = 0;
							};

							video.onseeked = () => {
								// Create canvas and context
								const canvas = document.createElement('canvas');
								canvas.width = video.videoWidth;
								canvas.height = video.videoHeight;
								const ctx = canvas.getContext('2d');

								// Draw the video frame on the canvas
								ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

								// Convert canvas to blob
								canvas.toBlob((blob) => {
									const thumbnailName = fileInfo.name.replace(/\.[^/.]+$/, '') + '_thumbnail.jpg';

									fileInfo.thumbnail = new File([blob], thumbnailName, { type: 'image/jpeg' });
									resolve(video.duration);
								}, 'image/jpeg', 0.7); // 0.7 is the image quality (0-1)
							};
						});

						video.src = fileInfo.previewUrl;

						// addToFiles queues a copy of fileInfo, and this probe can finish after
						// it does (a larger file, or a recording's seek to the end), so copy what
						// it found onto the queued file too, or it saves with no duration and the
						// default thumbnail (MEDIA-308)
						const applyToQueued = () => {
							const queued = this.files.find(f => f.previewUrl === fileInfo.previewUrl);

							if (!queued || queued === fileInfo) {
								return;
							}

							if (fileInfo.thumbnail && !queued.thumbnail) {
								queued.thumbnail = fileInfo.thumbnail;
							}

							if (fileInfo.duration && !(Number(queued.duration) > 0)) {
								queued.duration = fileInfo.duration;
							}
						};

						getDuration.then(duration => {
							if (Number.isFinite(duration) && duration > 0) {
								fileInfo.duration = duration;
								applyToQueued();
								return;
							}

							// Recorded .webm has no duration in its header, so the thumbnail pass
							// reads Infinity. getVideoDuration seeks to the end to resolve it.
							this.getVideoDuration(fileInfo).then(applyToQueued);
						});
					} else {
						fileInfo.type = 'doc';
					}

					if (this.isExtensionAllowed(fileInfo.extension)) {
						validFiles.push(fileInfo);
					} else {
						invalidExtensions.push(file.name);
					}
				});

				console.log('oversizedFiles', oversizedFiles);
				if (oversizedFiles.length > 0) {
					const countLabel = oversizedFiles.length === 1 ? 'file' : 'files';
					this.openAlert(
						'error',
						'Error',
						`The following ${countLabel} exceed the maximum file size of 200MB: ${oversizedFiles.join(', ')}`
					);
				}

				console.log('validFiles', validFiles, 'invalidExtensions', invalidExtensions);

				this.alertInvalidExtensions(invalidExtensions);

				const filesWithDimensions = await Promise.all(
					validFiles.map(fileInfo => {
						if (fileInfo.type === 'image') {
							return this.getImageDimensions(fileInfo);
						}

						return fileInfo;
					})
				);

				this.addToFiles(filesWithDimensions);
			},
			triggerFileInput() {
				this.$refs.fileInput.click();
			},
			removeFile(file) {
				let idx = null;
				const normalizeName = (name) => String(name || '').trim().toLowerCase().replace(/[-_]/g, '');

				idx = this.files.findIndex(f => normalizeName(f.name) === normalizeName(file.name));

				if (idx === -1) {
					idx = this.files.findIndex(f => f.previewUrl === file.previewUrl);
				}

				if (idx !== -1) {
					if (this.files[idx] && this.files[idx].previewUrl) {
						try {
							URL.revokeObjectURL(this.files[idx].previewUrl);
						} catch (e) {
							console.error('Error revoking object URL:', e);
						}
					}

					const wasActive = idx === this.activeFileIndex;

					this.files.splice(idx, 1);

					if (this.files.length === 0) {
						this.activeFileIndex = 0;
					} else if (idx < this.activeFileIndex) {
						this.activeFileIndex--;
					} else if (wasActive) {
						this.activeFileIndex = Math.min(this.activeFileIndex, this.files.length - 1);
					}
				}

				if (this.$refs.fileInput) {
					this.$refs.fileInput.value = '';
				}

				if (this.existingFileList.length > 0) {
					const existingIndex = this.existingFileList.findIndex(f => normalizeName(f.file.name) === normalizeName(file.name));

					if (existingIndex !== -1) {
						this.existingFileList.splice(existingIndex, 1);
					}

					if (this.existingFileList.length > 0) {
						this.existFileProps = {
							file : this.existingFileList[0].file,
							asset: this.existingFileList[0].asset,
							media: this.existingFileList[0].media
						};
						this.createEfComponent(this.existFileProps);
					} else {
						this.existingFile = false;
					}
				}

				if (this.files.length === 0 ) {
					this.readyToUpload = false;
					this.queueExpanded = false;
					this.fileUrl       = '';
				}

				this.isLoading = false;
			},
			importFile(thirdParty = false, meta = null) {
				if (!this.fileUrl) {
					this.importErrors.title = 'Please enter the URL of the file you want to import';
				}
				console.log('thirdParty', thirdParty);
				if (!thirdParty) {
					if (!this.validateFileUrl()) {
						this.openAlert(
							'error',
							'Error',
							this.importErrors.title
						);
						return;
					}
				}

				// MEDIA-279 (QA): a web import that fails after the url checks pass (a bad
				// host, a missing file, a server error) gets one plain message instead of
				// the server's own text; stock picks keep theirs
				const failMessage = thirdParty
					? 'Unable to import the selected file.'
					: 'The file URL you are attempting to import is invalid. Please choose another URL.';

				const formData = new FormData();

				formData.append('file_url', this.fileUrl);

				if (this.thumbUrl) {
					formData.append('thumb_url', this.thumbUrl);
				}

				fetch(this.$baseUri + '/Media/importFile/', {
					method: 'POST',
					body  : formData,
				})
					.then(response => response.json())
					.then(data => {
						console.log('data', data, 'third Party', thirdParty);

						if (data.status === 'error') {
							this.openAlert(
								'error',
								'Error',
								thirdParty ? (data.message || failMessage) : failMessage
							);
							return;
						}

						if (!data.name || !data.path) {
							this.openAlert(
								'error',
								'Error',
								failMessage
							);
							return;
						}

						if (Number(data.size) > this.maxFileSize) {
							this.openAlert(
								'error',
								'Error',
								`The file "${data.name}" exceeds the maximum file size of 200MB`
							);
							return;
						}

						const fileInfo = {
							name        : data.name,
							size        : Number(data.size) || 0,
							extension   : data.name.split('.').pop().toLowerCase(),
							previewUrl  : this.$baseUri + '/' + data.path + data.name,
							filePath    : data.path + data.name,
							originalFile: null,
							fileOrigin  : 'import',
							type        : data.type
						};

						console.log('fileInfo Origin', fileInfo.origin, 'third Party', thirdParty);
						if (thirdParty) {
							fileInfo.fileOrigin = 'stock';

							if (String(data.name).includes('tmp_data')) {
								fileInfo.name = this.importFilename;
								fileInfo.filePath = data.path + this.importFilename;
							}

						}

						fileInfo.extension = fileInfo.name.split('.').pop().toLowerCase();

						if (data.width && data.height) {
							fileInfo.width = data.width;
							fileInfo.height = data.height;
						}

						if (data.thumb_path) {
							fileInfo.thumbPath = data.thumb_path;
						}

						if (!this.isExtensionAllowed(fileInfo.extension)) {
							this.alertInvalidExtensions([fileInfo.name]);
							return;
						}

						// Stock providers report the duration with their search results, so prefer
						// that over probing the file we just imported.
						const providedDuration = Number(meta && meta.duration);

						if (fileInfo.type === 'video' && Number.isFinite(providedDuration) && providedDuration > 0) {
							fileInfo.duration = Math.floor(providedDuration);
						}

						this.addToFiles([fileInfo]);
						this.fileUrl = '';

						if (fileInfo.type === 'video') {
							const queuedFile = this.files.find(f => f.filePath === fileInfo.filePath);

							// Reads metadata off the imported file in the background so the queue
							// is not held up while a large video downloads.
							if (queuedFile) {
								this.getVideoDuration(queuedFile);
							}
						}
					})
					.catch(() => {
						this.openAlert(
							'error',
							'Error',
							failMessage
						);
					});
			},
			// MEDIA-279 (QA): the Pending Uploads tray's Remove all, which confirms and
			// then clears the queue the way Cancel All does (removeAllFiles). Nothing has
			// been uploaded yet, so nothing is lost but the list.
			confirmRemoveAllFiles() {
				const count = this.files.length;

				if (!count) {
					return;
				}

				Adzuki.CustomConfirm.destructive({
					title           : count > 1 ? 'Remove all ' + count + ' pending uploads?' : 'Remove the pending upload?',
					content         : 'Nothing has been uploaded yet; the files just come off the list.',
					confirm_btn_text: count > 1 ? 'Remove all' : 'Remove it',
					cancel_btn_text : count > 1 ? 'Keep them' : 'Keep it',
					confirm         : () => {
						for (const file of this.files) {
							if (file.previewUrl && String(file.previewUrl).startsWith('blob:')) {
								try {
									URL.revokeObjectURL(file.previewUrl);
								} catch (e) {
									// already released
								}
							}
						}

						this.removeAllFiles();
					},
				});
			},
			goToFIle(index) {
				if (index < 0 || index >= this.files.length) {
					return;
				}

				this.activeFileIndex = index;
			},
			resolveFileIndex(file) {
				if (!file) {
					return this.activeFileIndex;
				}

				let fileIndex = this.files.findIndex(f => f === file);

				if (fileIndex === -1) {
					fileIndex = this.files.findIndex(f => f.previewUrl === file.previewUrl && f.name === file.name);
				}

				if (fileIndex === -1) {
					fileIndex = this.files.findIndex(f => f.name === file.name);
				}

				return fileIndex;
			},
			closeCropper(fileIndex = null) {
				let restoreIndex = this.croppingFileIndex;

				if (fileIndex !== null && fileIndex >= 0) {
					restoreIndex = fileIndex;
				}

				this.showCropper       = false;
				this.croppingFileIndex = null;

				this.$nextTick(() => {
					if (restoreIndex !== null && restoreIndex >= 0 && restoreIndex < this.files.length) {
						this.activeFileIndex = restoreIndex;
					}
				});
			},
			uploadAllFiles() {
				const fileUploadForms = this.$refs.fileUploadForm;

				if (!fileUploadForms || fileUploadForms.length === 0) {
					console.error('No file upload forms found');
					return;
				}

				const allFileFormsData = fileUploadForms.map((formComponent, index) => {
					return {
						index   : index,
						fileForm: formComponent.fileForm,
						file    : formComponent.file || this.files[index]
					};
				});

				this.sendAllFilesToServer(allFileFormsData);
			},
			getActiveUploadForm() {
				const formsRef = this.$refs.fileUploadForm;
				let forms = [];

				if (Array.isArray(formsRef)) {
					forms = formsRef;
				} else if (formsRef) {
					forms = [formsRef];
				}

				return forms[this.activeFileIndex] || forms[0] || null;
			},
			saveUpload() {
				const form = this.getActiveUploadForm();

				if (!form) {
					return;
				}

				// Embedded (sectionInfo): may open cropper before upload
				if (this.sectionInfo && typeof form.determineFileUpload === 'function') {
					form.determineFileUpload();
					return;
				}

				if (typeof form.uploadFile === 'function') {
					form.uploadFile(false);
				}
			},
			cancelActiveUpload() {
				const form = this.getActiveUploadForm();

				if (form && typeof form.cancelUpload === 'function') {
					form.cancelUpload();
				}
			},
			saveAllUploads() {
				const form = this.getActiveUploadForm();

				if (form && typeof form.uploadAllFiles === 'function') {
					form.uploadAllFiles();
				}
			},
			cancelAllUploads() {
				const form = this.getActiveUploadForm();

				if (form && typeof form.cancelAllFiles === 'function') {
					form.cancelAllFiles();
				}
			},
			onFormLoading(isLoading) {
				this.isLoading = isLoading;

				if (!isLoading) {
					this.savingCopy = false;
				}
			},
			removeAllFiles() {
				this.files           = [];
				this.readyToUpload   = false;
				this.queueExpanded   = false;
				this.fileUrl         = '';
				this.isLoading       = false;
				this.activeFileIndex = 0;
			},
			async sendAllFilesToServer(allFileFormsData) {
				const uploadPromises = allFileFormsData.map(async (formData, index) => {
					const url     = this.$baseUri + '/Media/saveMediaHubFile/';
					const mediaHubItem = new FormData();

					// Append form data
					mediaHubItem.append('title', formData.fileForm.title);
					mediaHubItem.append('description', formData.fileForm.description);
					mediaHubItem.append('tags', JSON.stringify(formData.fileForm.tags));
					mediaHubItem.append('favorite', formData.fileForm.isFavorite ? 1 : 0);
					mediaHubItem.append('global', formData.fileForm.isGlobal ? 1 : 0);
					mediaHubItem.append('share_franchise', formData.fileForm.shareFranchise ? 1 : 0);

					if (formData.file && formData.file.name) {
						mediaHubItem.append('file', formData.file.originalFile);
						mediaHubItem.append('file_path', formData.file.filePath);
						mediaHubItem.append('file_origin', formData.file.fileOrigin || null);
						mediaHubItem.append('type', formData.file.type);
						mediaHubItem.append('extension', formData.file.extension);
						mediaHubItem.append('size', formData.file.size);

						if (formData.file.type === 'image') {
							mediaHubItem.append('height', formData.file.height);
							mediaHubItem.append('width', formData.file.width);
						}

						if (formData.file.type === 'video') {
							const duration = Number(formData.file.duration);

							mediaHubItem.append('thumbnail', formData.file.thumbnail);

							if (Number.isFinite(duration) && duration > 0) {
								mediaHubItem.append('duration', Math.floor(duration));
							}

							if (formData.file.thumbPath) {
								mediaHubItem.append('thumb_path', formData.file.thumbPath);
							}

							if (formData.file.captions) {
								mediaHubItem.append('captions', formData.file.captions);
							}

							if (formData.fileForm.client_id) {
								mediaHubItem.append('client_id', formData.fileForm.client_id);
							}
						}
					}

					// Add section
					if (this.$section) {
						mediaHubItem.append('section', this.$section);
					} else if (this.sectionInfo && this.sectionInfo.internal_name) {
						mediaHubItem.append('section', this.sectionInfo.internal_name);
					}

					// Pass the effective needs_approval (after URL override on sectionInfo)
					// so the server can overwrite the DB section flag for this request.
					if (typeof this.$needsApproval === 'boolean') {
						mediaHubItem.append('needs_approval', Number(this.sectionInfo?.needs_approval) === 1 ? '1' : '0');
					}

					try {
						const response = await fetch(url, {
							method: 'POST',
							body  : mediaHubItem,
						});

						return await response.json();

					} catch (error) {
						console.error(`Error uploading file ${index}:`, error);
						return error;
					}
				});

				try {
					const results = await Promise.all(uploadPromises);
					let message  = '';
					let success  = [];
					let error    = [];
					const saved  = [];

					// Handle results
					results.forEach((result, key) => {
						const fileName = allFileFormsData[key].file?.name || 'Unknown File';

						if (!result || result instanceof Error) {
							error.push(`${fileName} could not be uploaded. Please try again.`);
						} else if (result.status === 'existing_asset' ) {
							this.existingFileList.push(result.existing_asset);
						} else if (result.status === 'error' ) {
							error.push(`${fileName} ${result.message}`);
						} else {
							success.push(result);
							saved.push(allFileFormsData[key].file);
						}
					});

					// Files that saved are done. Only the duplicates (and any that failed) stay
					// queued, so answering a duplicate never re-sends a file already saved.
					// Matched by the raw object or the name (the queue holds one file per name),
					// since the form refs are neither in queue order nor the same proxies.
					if (saved.length > 0) {
						const raw       = item => (Vue.toRaw ? Vue.toRaw(item) : item);
						const savedRaw  = saved.map(raw);
						const savedName = saved.map(done => this.normalizeFileName(done && done.name));

						this.files           = this.files.filter(file =>
							!savedRaw.includes(raw(file)) && !savedName.includes(this.normalizeFileName(file.name))
						);
						this.activeFileIndex = 0;
					}

					if (success.length > 0) {
						if (this.sectionInfo) {
							const mediaIds = success
								.map(result => result.media_id)
								.filter(id => id !== undefined && id !== null && String(id).length > 0);

							if (mediaIds.length > 0) {
								if (Number(this.sectionInfo.vue_app) === 1) {
									// Consumers normalise this with Array.isArray or [].concat, so a
									// joined string reads as one malformed id and a batch upload
									// attaches only its first file.
									this.$emit('selected-media', {
										media_id: mediaIds,
									});
								} else {
									// postMessage consumers append this straight to FormData
									this.sendMediaToParent({
										media_id: mediaIds.join(','),
									});
								}
							}
						} else {
							let restricted = 0;
							let approved   = 0;
							let pending    = 0;

							success.forEach(successResults => {
								switch (successResults.status) {
									case 'restricted':
										restricted++;
										break;
									case 'pending':
										pending++;
										break;
									case 'approved':
										approved++;
										break;
									default:
										approved++;
								}
							});

							const total = pending + approved + restricted;

							message = `${total} files have been saved successfully. Results below: <br><br><ul><li>${restricted} files currently have limited approval for use.</li><li>${approved} files currently have unlimited approval for use.</li></ul> Files with limited approval may be submitted to Home Office for review.`;

							this.openAlert('success', 'Success', message);
						}
					}

					if (error.length > 0) {
						error.forEach(error => {
							message += error + '\n';
						});
						this.openAlert('error', 'Error', message);
					}

					if (this.existingFileList.length > 0) {
						this.processNextExistingFile();
					} else {
						this.files           = [];
						this.readyToUpload   = false;
						this.queueExpanded   = false;
						this.activeFileIndex = 0;
					}
				} catch (error) {
					console.error('Error during batch upload:', error);
				} finally {
					this.isLoading = false;
				}
			},
			openCropper(file = null) {
				const fileIndex = this.resolveFileIndex(file);

				this.croppingFileIndex = fileIndex >= 0 ? fileIndex : this.activeFileIndex;
				this.cropperProps      = {
					img        : file || this.files[this.croppingFileIndex],
					sectionInfo: this.sectionInfo,
				};

				if (!this.sectionInfo) {
					this.componentToRender = Adzuki.VueComponents.AdzukiVueImageCropper;
				}

				this.showCropper = true;
			},
			closeModal() {
				this.closeCropper();
			},
			addRecordedVideo(record) {
				let files = [];
				files.push(record);
				this.handleFiles(files);
			},
			emittedComponentData(fileInfo) {
				if (typeof fileInfo === 'string' && fileInfo === 'cancel-crop') {
					this.cancelCrop();
					return;
				}

				let fileIndex = this.croppingFileIndex;

				if (fileIndex === null || fileIndex < 0) {
					fileIndex = this.files.findIndex(file => file.name === fileInfo.name);
				}

				if (fileIndex !== -1 && fileIndex !== null) {
					const existingFile = this.files[fileIndex];

					// Crop updates file bytes/preview/dimensions only — keep queue name stable
					this.files[fileIndex] = {
						...existingFile,
						originalFile: fileInfo.originalFile,
						previewUrl  : fileInfo.previewUrl,
						size        : fileInfo.size,
						extension   : fileInfo.extension || existingFile.extension,
						type        : fileInfo.type || existingFile.type,
						width       : fileInfo.width,
						height      : fileInfo.height,
						filePath    : fileInfo.filePath === undefined ? existingFile.filePath : fileInfo.filePath,
					};
				}

				if (this.sectionInfo) {
					this.closeCropper(fileIndex);

					this.$nextTick(() => {
						const formsRef = this.$refs.fileUploadForm;
						const targetForm = Array.isArray(formsRef) ? formsRef[fileIndex] : formsRef;

						if (targetForm && typeof targetForm.uploadFile === 'function') {
							targetForm.uploadFile();
						}
					});
				} else {
					this.closeCropper(fileIndex);

					if (fileInfo.type === 'image') {
						this.openAlert('success', 'Success', 'Image cropped successfully');
					}
				}
			},
			createEfComponent(props) {
				this.existFileProps = props;
				this.existingFile   = true;
			},
			processNextExistingFile() {
				console.log('processNextExistingFile', this.existingFileList);
				if (this.existingFileList.length > 0) {
					this.existFileProps = {
						file : this.existingFileList[0].file,
						asset: this.existingFileList[0].asset,
						media: this.existingFileList[0].media
					};
					this.createEfComponent(this.existFileProps);
				} else {
					this.existingFile   = false;
					this.existFileProps = null;
					if (this.files.length === 0) {
						this.readyToUpload   = false;
						this.activeFileIndex = 0;
					}
				}
			},
			handleExistingFile(eventData) {
				let fileIndex  = null;

				switch (eventData.type) {
					case 'cancel':
						this.removeFile(eventData.file);
						// this.processNextExistingFile();
						break;
					case 'upload':
						// eventData.file came back from the server, so its name has already been
						// through sanitizeFilename. Compare against the queue the same way.
						fileIndex = this.files.findIndex(f =>
							f === eventData.file ||
							(f.previewUrl && eventData.file && f.previewUrl === eventData.file.previewUrl) ||
							this.sanitizeFileName(f.name) === this.sanitizeFileName(eventData.file.name)
						);

						if (fileIndex === -1) {
							this.openAlert('error', 'Error', 'We could not match that file to your upload queue. Please try uploading it again.');
							return;
						}

						if (this.existingFileList.length > 0) {
							const existingIndex = this.existingFileList.findIndex(f =>
								this.sanitizeFileName(f.file.name) === this.sanitizeFileName(eventData.file.name)
							);
							if (existingIndex !== -1) {
								this.existingFileList.splice(existingIndex, 1);
							}
						}
						// Add Media keeps a saving panel up until the copy finishes (MEDIA-282)
						this.savingCopy   = true;
						this.existingFile = false;
						if (!this.readyToUpload) {
							this.readyToUpload = true;
						}
						this.$nextTick(() => {
							const formsRef   = this.$refs.fileUploadForm;
							const queued     = this.files[fileIndex];
							const raw        = item => (Vue.toRaw ? Vue.toRaw(item) : item);
							// v-for refs are not in queue order, so find the form holding this file
							const targetForm = Array.isArray(formsRef)
								? formsRef.find(form => form.file && (
									raw(form.file) === raw(queued) ||
									this.normalizeFileName(form.file.name) === this.normalizeFileName(queued && queued.name)
								))
								: formsRef;

							if (!targetForm || typeof targetForm.uploadFile !== 'function') {
								this.isLoading  = false;
								this.savingCopy = false;
								this.openAlert('error', 'Error', 'We were unable to upload a copy of this file. Please try again.');
								return;
							}

							targetForm.uploadFile(true);
						});

						this.processNextExistingFile();
						break;
					case 'select': {
						let url = this.$baseUri + '/Media/selectMediaFile/';

						const formData = new FormData();
						formData.append('id', eventData.media.id);

						if (this.$section) {
							formData.append('section', this.$section);
						}

						// Pass the effective needs_approval (after URL override on sectionInfo)
						// so the server can overwrite the DB section flag for this request.
						if (typeof this.$needsApproval === 'boolean') {
							formData.append('needs_approval', Number(this.sectionInfo?.needs_approval) === 1 ? '1' : '0');
						}

						if (this.existingFileList.length > 0) {
							const existingIndex = this.existingFileList.findIndex(f => f.media && f.media.id === eventData.media.id);
							if (existingIndex !== -1) {
								this.existingFileList.splice(existingIndex, 1);
							}
						}

						fetch(url, {
							method: 'POST',
							body  : formData,
						})
							.then(response => response.json())
							.then(data => {

								if (data.status === 'pending') {
									this.closeCropper();

									const needsPopForm = Number(this.sectionInfo?.needs_approval) === 1 ||
										Number(data.matches_found) === 1;

									if (needsPopForm) {
										this.handlePendingApproval(data);
									} else {
										this.openAlert('success', data.message);

										if (this.sectionInfo?.vue_app === 1) {
											this.$emit('selected-media', data);
										} else {
											this.sendMediaToParent(data);
										}
									}

									this.processNextExistingFile();
									return;
								}

								if (this.sectionInfo.vue_app === 1) {
									this.$emit('selected-media', data);
									this.processNextExistingFile();
									return;
								}

								this.sendMediaToParent(data);
								this.processNextExistingFile();
							})
							.catch(error => {
								console.error('Error:', error);
								this.processNextExistingFile();
							});
						break;
					}
					default:
						break;
				}
			},
			getAllowedExtensions() {
				let url = `${this.$baseUri}/Media/getAllowedExtensions`;

				if (this.sectionInfo) {
					url += '/section:' + this.sectionInfo.internal_name;
				}

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error Fetching Allowed Extensions: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						// If data is returned, we set sectionInfo and create the stencilProps to send to the cropper
						if (data) {
							this.allowedExtensions = data;
						}
					})
					.catch(error => {
						console.error('Error fetching Media Sections:', error);
					});
			},
			cancelCrop() {
				this.closeCropper();
			},
			handlePopForm(media_id) {
				this.popFormMediaId = media_id;
				this.showPopForm    = true;
			},
			handlePendingApproval(data) {
				const file = data.file;
				const payload = { ...data };

				delete payload.file;

				if (file) {
					this.removeFile(file);
				}

				const needsPopForm = Number(this.sectionInfo?.needs_approval) === 1 ||
					Number(payload.matches_found) === 1;

				if (needsPopForm) {
					this.$emit('pending-approval', payload);

					if (Number(this.sectionInfo?.needs_approval) !== 1) {
						this.handlePopForm(payload.media_id);
					}
				}
			},
			handlePopSubmit(file) {
				this.popFormMediaId = null;
				this.showPopForm    = false;
				this.removeFile(file);
			},
			handleSelectedMedia(media) {
				this.$emit('selected-media', media);
			},
			validateFileUrl() {
				this.importErrors = {};

				const value = this.fileUrl.trim();

				if (!value) {
					return true;
				}

				try {
					const u = new URL(value);
					if (!['http:', 'https:'].includes(u.protocol)) {
						this.importErrors.title = 'URL must start with http:// or https://';
						return false;
					}

					const allowedImageExt = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tif', 'tiff', 'svg'];
					const allowedVideoExt = ['mp4', 'mov', 'avi', 'webm'];
					const allowedMediaExt = [...allowedImageExt, ...allowedVideoExt];
					const invalidExtensionMessage = 'URL must end with an image or video file name (i.e. jpg, png, mp4, mov, etc.)';

					const normalizedPath = (u.pathname || '').replace(/\/+$/, '');
					const lastSegment = decodeURIComponent(normalizedPath.split('/').pop() || '');

					const match = lastSegment.match(/\.([a-z0-9]+)$/i);
					if (!match) {

						this.importErrors.title = invalidExtensionMessage;
						return false;
					}

					const ext = match[1].toLowerCase();

					if (!allowedMediaExt.includes(ext)) {
						this.importErrors.title = invalidExtensionMessage;
						return false;
					}


				} catch (e) {
					this.importErrors.title = 'Please enter a valid URL starting with http:// or https://';
					return false;
				}
				return true;
			},
			handleImageService(items) {
				console.log('handleImageService', items);
				items.forEach(item => {
					this.fileUrl        = item.downloadUrl;
					this.thumbUrl       = item.type === 'video' ? item.imageUrl : null;
					this.importFilename = item.filename;
					this.importFile(true, item);
				});

			},
			fileOrigin(origin) {
				switch (origin) {
					case 'uploaded':
						return 'Manually Uploaded';
					case 'stock':
						return 'Select Stock Media';
					case 'import':
						return 'Import From Web';
					case 'recorded':
						return 'Recorded Video';
					default:
						return '';
				}
			},
			getDefaultTab() {
				if (this.sectionInfo && this.sectionInfo.allowed_types) {
					const types = this.sectionInfo.allowed_types
						.split(',')
						.map(type => type.trim())
						.filter(Boolean);

					if (types.length === 1 && types[0] === 'doc') {
						return 'upload';
					}
				}

				return 'stock';
			}
		},
		created() {
			this.getAllowedExtensions();

			const sessionTab = sessionStorage.getItem('upload-tab');
			const initialTab = sessionTab || this.getDefaultTab();

			this.tabToggle(initialTab);
		}
	};

	Adzuki.VueComponents.AdzukiFileUpload = component;
}(jQuery, window.Adzuki || {}));
